export default "__VITE_ASSET__DrwOqn6C__"